import { render, staticRenderFns } from "./inten.vue?vue&type=template&id=70c838d2&scoped=true&"
import script from "./inten.vue?vue&type=script&lang=js&"
export * from "./inten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c838d2",
  null
  
)

export default component.exports